import type { User } from '@store/slices/users/usersSlice';
import { WEB_USER } from '@routes/helpers';

export type PortalRole = string;

export type RoleResolverContext = {
  userInfo: User | null;
  isContractorVersion: boolean;
};

type RoleRule = {
  role: PortalRole;
  match: (ctx: RoleResolverContext) => boolean;
};

const roleRules: RoleRule[] = [
  // { role: CONTRACTOR_USER, match: ({ userInfo }) => userInfo?.type?.value === CONTRACTOR_USER }, // Contractor Portal, once built
  // { role: 'payerPortal',      match: ({ userInfo }) => userInfo?.type?.value === 'payerPortal' },       // Payer Portal, once built
  // { role: 'memberPortal',     match: ({ userInfo }) => userInfo?.type?.value === 'memberPortal' },      // Member Portal, once built

  // Fallback — rideshare is the only portal implemented today.
  { role: WEB_USER, match: () => true },
];

export const resolveRole = (ctx: RoleResolverContext): PortalRole | null => {
  if (!ctx.userInfo) return null;
  const rule = roleRules.find((r) => r.match(ctx));
  return rule ? rule.role : null;
};
